module.exports = __webpack_public_path__ + "media/guac_sweepstakes/1k-scholarship-success-sweeps-20dbf919.jpg";